import axios from 'axios';
import qs from 'qs';

function Api(store) {
  const instance = axios.create({
    baseURL: process.env.VUE_APP_API_HOST,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${window.localStorage.getItem('accountObj')}`,
    },
    paramsSerializer(params) { return qs.stringify(params); },
  });

  instance.interceptors.response.use(
    (response) => {
      if (Object.prototype.hasOwnProperty.call(response.data, 'error') && response.data.error) {
        const errors = response.data.error;

        if (Array.isArray(errors)) {
          store.dispatch('errors/addError', errors.join('<br>'), { root: true });
        } else {
          store.dispatch('errors/addError', errors, { root: true });
        }
      }

      return response.data;
    },
    (error) => {
      console.log('api.error', error.response);
      if (Object.prototype.hasOwnProperty.call(error.response, 'status') && error.response.status === 404) {
        store.dispatch('errors/addError', 'Роут не найден', { root: true });
      } else if (Object.prototype.hasOwnProperty.call(error.response, 'status') && error.response.status === 401) {
        store.dispatch('account/removeToken', error, { root: true });
        store.dispatch('errors/addError', 'Токен авторизации устарел, обновите страницу', { root: true });
      } else {
        store.dispatch('errors/addError', error, { root: true });
      }

      return Promise.reject(error.response);
    },
  );

  return instance;
}

export default Api;
